
        import type { TemplateResult, TemplateRootPropsForTag } from 'Components/types';
type fitmentTableTabDesktopRTRootProps = TemplateRootPropsForTag<'a'>;
import { createElement as _createElement } from 'preact';
import { map as _map } from 'Utils/array';
import _translate from 'Utils/translate';
export default function fitmentTableTabDesktopRT(): TemplateResult<fitmentTableTabDesktopRTRootProps> {
    return this.vehicleSpecific || this.manyFitments ? _createElement('a', {
        'className': 'nav-link d-flex',
        'id': 'product-tabs-tab-fitment',
        'data-toggle': 'tab',
        'href': '#product-tabs-content-fitment',
        'role': 'tab',
        'aria-controls': 'product-tabs-content-fitment',
        'aria-selected': 'true',
        'key': '0'
    }, _createElement('span', {}, 'Fitment')) : null;
}
        export const componentNames = []